// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { FieldsFactory } from '../Factory/FieldsFactory';
import { Message } from '@shared/utils/DirectMessages/Message';
import { PFixMessage } from './PFixMessage';
export class SnapshotRequestMessage extends PFixMessage {
    constructor(fieldSet) {
        super(Message.CODE_GET_SNAPSHOT_REQUEST, fieldSet);
    }
    getInstrumentTradableID() {
        return this.getFieldValue(FieldsFactory.FIELD_TRADABLE_INSTRUMENT_ID);
    }
    setInstrumentTradableID(id) {
        this.setFieldValue(FieldsFactory.FIELD_TRADABLE_INSTRUMENT_ID, id);
    }
    getRouteId() {
        return this.getFieldValue(FieldsFactory.FIELD_ROUTE_ID);
    }
    setRouteId(id) {
        this.setFieldValue(FieldsFactory.FIELD_ROUTE_ID, id);
    }
}
